import React from 'react'

import { Button, Dialog, Icon } from 'src/chrome'

import styles from './campaignShare.module.scss'
import { DialogTitle, TextField } from '@material-ui/core'
import DialogContent from '@material-ui/core/DialogContent'
import { useState } from 'src/hooks'
import { CampaignLineCard } from '..'
import { CampaignLine } from '../CampaignLine/CampaignLineCard'
import { Spacer, Text } from '@sendoutcards/quantum-design-ui'

type CampaignShareProps = {
  campaignTitle: string
  lines?: CampaignLine[]
  onClick: () => void
  onSubmit: (user: string) => void
}

const CampaignShare: React.FC<CampaignShareProps> = props => {
  const { campaignTitle, children, lines, onClick, onSubmit } = props
  const [user, setUser] = useState('')

  return (
    <div>
      <Dialog scroll={'paper'} open={true} onClose={onClick}>
        <DialogTitle disableTypography={true}>
          <div style={{ display: 'flex', color: '#333' }}>
            <Text type="caption" color="primaryHeading">
              Share campaign:{' '}
            </Text>
            <Spacer space="x1" orientation="horizontal" />
            <Text type="caption" weight="bold">
              {campaignTitle}
            </Text>
            <div style={{ marginLeft: 'auto' }}>
              <span className={styles.close} onClick={() => onClick()}>
                <Icon icon={'CLOSE'} color={'#6f8394'} size={18} />
              </span>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div className={styles.shareDetails}>
            <div style={{ margin: '22px auto' }}>
              <CampaignLineCard title={campaignTitle} lines={lines} />
            </div>
            {children}
            <div className={styles.details}>
              <Text type="largeBody" color="primaryHeading">
                Campaign Details:
              </Text>
              <ul
                className={styles.campaignDetails}
                style={{ marginBottom: '15px' }}
              >
                <li>
                  <Text type="body">
                    Touches:{' '}
                    {lines?.length
                      ? lines?.length
                      : 'This campaign has no cards'}
                  </Text>
                </li>
              </ul>
              <form
                className={styles.shareForm}
                onSubmit={() => onSubmit(user)}
              >
                <div className={styles.oneField}>
                  <TextField
                    name={'username'}
                    label={'Username'}
                    value={user}
                    placeholder={'Username'}
                    onChange={event => setUser(event.target.value)}
                    fullWidth={true}
                    required={true}
                  />
                </div>
                <Button
                  type={'submit'}
                  title={'Share'}
                  buttonColor={'pink'}
                  className={styles.shareButton}
                />
              </form>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}
export default CampaignShare
